import { CardOnFileContextToActions } from './context-to-actions';
import { CardOnFileContextToForm } from './context-to-form';

const ContextToPropsNamespace = {
  Actions: CardOnFileContextToActions,
  Form: CardOnFileContextToForm,
};

export { ContextToPropsNamespace as ContextToProps };
